import React from "react";
import { useInView } from "react-intersection-observer";

const OfferCard = ({ iconClass, text, delay = 0 }) => {
  const { ref, inView } = useInView({ triggerOnce: false, threshold: 0.1 });

  return (
    <div
      ref={ref}
      className={`bg-white p-6 rounded-lg shadow-lg transform transition duration-700 ease-out h-full flex flex-col ${
        inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
      }`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      <i className={`${iconClass} text-blue-500 text-4xl`}></i>
      <p className="mt-4">{text}</p>
    </div>
  );
};

const Offers = () => {
  return (
    <section
      id="offers"
      className="py-16 px-6 bg-gray-200 md:px-16 scroll-mt-10"
    >
      <div className="container mx-auto text-center">
        <h2 className="text-3xl font-bold mb-6">
          <img
            src="/images/fire.png"
            className="mr-2 inline-block"
          />
          Hot Deals on Wheels!
        </h2>
        <div className="bg-cover bg-center bg-no-repeat p-6 rounded-xl">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:place-items-center">
            <OfferCard
              iconClass="fa-solid fa-arrows-rotate"
              text={
                <>
                  Exchange your bike or a scooter and get exchange bonus upto ₹3,000
                  <sup  className="text-red-500">*</sup>
                </>
              }
              delay={0}
            />
            <OfferCard
              iconClass="fas fa-gifts"
              text="Free accessories with every purchase"
              delay={150}
            />
            <OfferCard
              iconClass="fas fa-percent"
              text="Affordable EMI plans starting at just 5.9% interest"
              delay={300}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Offers;
